// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueAwesomeSwiper from "vue-awesome-swiper";
import ElementUI from "element-ui";
import "swiper/css/swiper.css";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import enLocale from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import api from "@/api"; // 导入全局接口
import { oosImgSuffix, isMobile } from "@/utils/common";
import "./assets/ct4.js";
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);
locale.use(enLocale);
//全局api接口
Vue.prototype.$api = api;
//图片路径压缩
Vue.prototype.$oosImgSuffix = oosImgSuffix;
Vue.prototype.$isMobile = isMobile;

// Vue.config.devtools = true
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js